<template>
  <div :class="classes" @click="checkHander" role="button"><slot> Click </slot></div>
</template>

<script>
export default {
  name: "CustomButton",
  props: ["lable", "data", "classes"],
  methods: {
    checkHander() {
      this.$emit("btnClicked", this.data);
    },
  },
};
</script>